import { Box, styled } from '@mui/material';

export default styled(Box)(({ theme }) => ({
  '& .card-product': {
    '& > td:last-child': {
      '& > div': {
        position: 'relative',
        right: 0,
        width: 'fit-content',
        height: 'fit-content',
        margin: '0 auto',
        '& > button': {
          borderRadius: 1000,
          padding: 0,
          minHeight: 0,
          minWidth: 0,
          width: 25,
          height: 25,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        },
        '& > div': {
          position: 'absolute',
          width: 'max-content',
          height: 'fit-content',
          backgroundColor: 'white',
          boxShadow: '0 0 3px 1px rgba(0,0,0,0.2)',
          zIndex: 1,
          margin: 5,
          padding: '5px 0',
          borderRadius: 5,
          display: 'flex',
          alignItems: 'stretch',
          flexDirection: 'column',
          '& > button': {
            borderRadius: 0,
            justifyContent: 'flex-end',
            color: 'rgba(0,0,0,0.75)',
            minWidth: 0,
            minHeight: 0,
            padding: '5px 15px 5px 30px'
          }
        }
      }
    },
    '&:not(.last)': {
      '& > td': {
        '&:last-child': {
          '& > div': {
            '& > div': {
              top: -10,
              right: -10
            }
          }
        }
      }
    },
    '&.last': {
      '& > td': {
        '&:last-child': {
          '& > div': {
            '& > div': {
              top: '100%',
              right: -10,
              transform: 'translateY(-100%)'
            }
          }
        }
      }
    }
  }
}));
